export type FilterType = 'checkbox' | 'radio' | 'numeric' | 'layout';

export const SUPPORTED_FILTER_TYPES: readonly FilterType[] = [
	'checkbox',
	'layout',
	'numeric',
];

export interface FiltersInterface {
	title: string;
	items?: FiltersItemInterface[];
	type: FilterType;
	maxValue?: number;
}

export interface FiltersItemInterface {
	name: string;
	value: string;
	frequency: number;
	icon?: string;
}

export type SortOptionValue =
	'name-asc' | 'name-desc' | 'price-asc' | 'price-desc';

export type SortSelection = SortOptionValue | 'none';

const SORT_OPTION_VALUES: readonly SortOptionValue[] = [
	'name-asc',
	'name-desc',
	'price-asc',
	'price-desc',
];

export function toSortSelection(value: string): SortSelection {
	return SORT_OPTION_VALUES.find((option) => option === value) ?? 'none';
}
